import { Link } from "wouter";
import type { User } from "../lib/types";
import { I } from "./Icons";
import { nymblLogoWhite } from "../assets";

interface Props {
  active?: string;
  user: User;
  onSignOut: () => void;
}

export function Sidebar({ active = "courses", user, onSignOut }: Props) {
  return (
    <aside className="gf-side">
      <div className="gf-side__brand">
        <img src={nymblLogoWhite} alt="Nymbl" />
        <div className="gf-side__brand-divider"></div>
        <div className="gf-side__brand-app">Git Fit</div>
      </div>

      <Link
        href="/dashboard"
        className={`gf-side__nav${active === "courses" ? " is-active" : ""}`}
      >
        <I.Book size={16} /> My courses
        <span className="gf-side__nav-meta">6</span>
      </Link>
      {user.isAdmin && (
        <Link
          href="/admin"
          className={`gf-side__nav${active === "admin" ? " is-active" : ""}`}
        >
          <I.Eye size={16} /> Team progress
        </Link>
      )}
      {user.isAdmin && (
        <Link
          href="/admin/users"
          className={`gf-side__nav${active === "users" ? " is-active" : ""}`}
        >
          <I.Users size={16} /> Manage users
        </Link>
      )}
      {user.isAdmin && (
        <Link
          href="/admin/courses"
          className={`gf-side__nav${active === "manage-courses" ? " is-active" : ""}`}
        >
          <I.Lock size={16} /> Manage courses
        </Link>
      )}
      {user.isAdmin && (
        <Link
          href="/admin/lectures"
          className={`gf-side__nav${active === "manage-lectures" ? " is-active" : ""}`}
        >
          <I.Lock size={16} /> Manage lectures
        </Link>
      )}
      <Link
        href="/sandbox"
        className={`gf-side__nav${active === "sandbox" ? " is-active" : ""}`}
      >
        <I.Terminal size={16} /> Sandbox
      </Link>

      <div className="gf-side__section">Resources</div>
      <Link
        href="/settings"
        className={`gf-side__nav${active === "settings" ? " is-active" : ""}`}
      >
        <I.Settings size={16} /> Settings
      </Link>

      <div className="gf-side__footer">
        <div className="gf-side__avatar">{user.initials}</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="gf-side__user-name">{user.name}</div>
          <div className="gf-side__user-role">{user.role}</div>
        </div>
        <button
          onClick={onSignOut}
          title="Sign out"
          style={{
            background: "transparent",
            border: 0,
            color: "rgba(255,255,255,0.5)",
            cursor: "pointer",
            padding: 4,
            borderRadius: 6,
          }}
        >
          <I.X size={14} />
        </button>
      </div>
    </aside>
  );
}
